module.exports = __webpack_public_path__ + "img/poster-the-factory-bloc.f0ccb2cd.png";